import { useTranslation } from 'react-i18next'
import { Reveal } from './reveal'

const STEPS = ['step1', 'step2', 'step3'] as const

export function HowItWorks() {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-6xl px-6 py-24">
      <Reveal className="text-center">
        <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
          {t('landing.how.title')}
        </h2>
      </Reveal>

      <div className="relative mt-16">
        <div
          className="landing-step-connector absolute left-[12%] right-[12%] top-12 hidden h-px md:block"
          aria-hidden
        />
        <Reveal stagger className="relative grid grid-cols-1 gap-8 md:grid-cols-3">
          {STEPS.map((step, idx) => (
            <div
              key={step}
              className="glass-card glass-hover relative rounded-2xl p-8 text-center"
            >
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-[color-mix(in_oklch,var(--foreground)_12%,transparent)] bg-[color-mix(in_oklch,var(--foreground)_6%,transparent)] text-base font-bold text-foreground">
                {idx + 1}
              </div>
              <h3 className="mt-5 text-lg font-semibold text-foreground">
                {t(`landing.how.${step}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {t(`landing.how.${step}.body`)}
              </p>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  )
}
